<template>
  <div>
    <Navbar />
    <el-scrollbar height="calc(100vh - 76px)" style="background: #eff1fe">
      <div id="container"><part3></part3></div>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { ref } from "vue"; // 导入 ref
import Navbar from "@/components/Navbar.vue"; // 导入 Navbar 组件
import part3 from "./common/part3"; // 导入 Navbar 组件
const activeindex = ref(1); // 定义 activeindex 为响应式数据
const navList = [
  {
    id: 1,
    path: "/",
    name: "抖音数据",
    icon: require("@/assets/images/icon-1-2.png"),
    isIcon: require("@/assets/images/icon-1-1.png"),
  },
  {
    id: 2,
    path: "/about",
    name: "抖音账号",
    icon: require("@/assets/images/icon-2-2.png"),
    isIcon: require("@/assets/images/icon-2-1.png"),
  },
];
const handlTabnav = (id) => {
  activeindex.value = id;
};
</script>

<style rel="stylesheet/scss" lang="scss">
/* 你可以在这里添加 home.vue 的样式 */
#container {
  padding: 22px !important;
  /* 容器样式 */
  padding: 16px 32px;
  .nav-left {
    width: 60px;
    padding-top: 10px;
    .nav-item {
      width: 60px;
      height: 78px;
      cursor: pointer;
      position: relative;
      .img-box {
        width: 100%;
        height: 100%;
        position: relative;
      }
      .img-box1 {
        .icon-b {
          width: 60px;
          height: 60px;
          position: absolute;
          top: 1px;
        }
        .icon-b1 {
          height: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .img-box2 {
        .icon-b {
          width: 60px;
          height: 60px;
          position: absolute;
          bottom: 0;
        }
        .icon-b1 {
          height: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .icon {
        width: 100%;
        left: 0;
        position: absolute;
      }
      .icon1 {
        top: 0;
      }
      .icon2 {
        bottom: 0;
      }
      .isIcon {
        left: 0;
        position: absolute;
        height: 78px;
      }
    }
  }
  .main-right {
    width: calc(100% - 88px);
    // background: #fff;
  }
}
</style>
